import React from 'react';
import { Navigate } from 'react-router-dom';

const Dashboard = () => {
    return <Navigate to={`${import.meta.env.BASE_URL}dashboard/resumen`} replace />;
};

export default Dashboard;
